/**
 * 捐赠概况卡 — 捐赠者级别 / 捐赠数量 / 捐赠价值 (legacy 我要捐赠 / 捐赠记录 顶部卡).
 */
import { THEMED_SURFACE_COLORS as C, ThemedPanel } from '../ui/ThemedSurface';

function fmtNum(v: string | undefined, digits = 2): string {
  const n = Number(v);
  if (!Number.isFinite(n)) return v ?? '0';
  return n.toLocaleString(undefined, { maximumFractionDigits: digits });
}

export interface DonationSummary {
  donor_level: string;
  total_donated: string;
  total_value: string;
}

function Col({ value, label, valueColor }: { value: string; label: string; valueColor: string }) {
  return (
    <div className="flex flex-1 flex-col items-center gap-1.5 px-1 text-center">
      <span className="text-base font-semibold leading-tight" style={{ color: valueColor }}>
        {value}
      </span>
      <span className="text-xs" style={{ color: C.muted }}>
        {label}
      </span>
    </div>
  );
}

export function DonationSummaryCard({
  summary,
  labels,
}: {
  summary?: DonationSummary;
  labels: { level: string; amount: string; value: string };
}) {
  const level = summary?.donor_level?.trim() || '—';
  const amount = `${fmtNum(summary?.total_donated, 0)} UO`;
  const value = `${fmtNum(summary?.total_value, 2)} $`;

  return (
    <ThemedPanel className="p-4">
      <div className="flex items-stretch">
        <Col value={level} label={labels.level} valueColor={C.gold} />
        <div className="w-px self-stretch" style={{ background: C.line }} />
        <Col value={amount} label={labels.amount} valueColor={C.text} />
        <div className="w-px self-stretch" style={{ background: C.line }} />
        <Col value={value} label={labels.value} valueColor={C.text} />
      </div>
    </ThemedPanel>
  );
}
